/* Fietspack lander — gallery, variant pick, sticky buy bar, checkout hand-off.
   The checkout URL is assembled at click time, so it never sits in the page source
   where a scraper or an ad reviewer can read it without clicking. */
(function () {
  'use strict';

  var node = document.getElementById('lander-data');
  if (!node) return;
  var D;
  try { D = JSON.parse(node.textContent); } catch (e) { return; }

  /* ── funnel analytics → ils.anonbusiness.com/board ───────────────
     view → engaged → gate → click. handoff logged by /pay/go, lead by /lead, paid by /pb. */
  var SID = (function () {
    try { var b = new Uint8Array(8); crypto.getRandomValues(b); return 'fp' + Array.from(b).map(function (x) { return ('0' + x.toString(16)).slice(-2); }).join(''); }
    catch (e) { return 'fp' + Date.now().toString(36) + Math.random().toString(16).slice(2, 8); }
  })();
  function ev(event, extra) {
    try {
      var qs = location.search || '';
      var qp = function (n) { var m = qs.match(new RegExp('[?&]' + n + '=([^&]+)')); return m ? decodeURIComponent(m[1]) : ''; };
      var ck = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
      var body = {
        event: event, store: 'fietspack', sid: SID, page: location.href, referer: document.referrer || '',
        product: D.title, variant: (picked && picked.label) || '',
        fbclid: qp('fbclid'), gclid: qp('gclid'),
        utm_source: qp('utm_source'), utm_medium: qp('utm_medium'),
      };
      for (var k in (extra || {})) body[k] = extra[k];
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon('https://ils.anonbusiness.com/ev', new Blob([s], { type: 'application/json' }));
      else fetch('https://ils.anonbusiness.com/ev', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: s, credentials: 'omit', keepalive: true });
    } catch (e) {}
  }

  /* first-touch attribution snapshot (same key as the shed rail) */
  try {
    if (!sessionStorage.getItem('fp_attr0')) {
      var _s = location.search || '', _snap = {};
      ['ttclid', 'fbclid', 'gclid', 'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'aff'].forEach(function (n) {
        var m = _s.match(new RegExp('[?&]' + n + '=([^&]+)'));
        if (m) { try { _snap[n] = decodeURIComponent(m[1].replace(/\+/g, '%20')); } catch (e) {} }
      });
      if (Object.keys(_snap).length) sessionStorage.setItem('fp_attr0', JSON.stringify(_snap));
    }
  } catch (e) {}

  /* ── gallery ─────────────────────────────────────────────────── */
  var stage = document.querySelectorAll('.gal__slide');
  var thumbs = document.querySelectorAll('.gal__thumbs button');
function show(i, userInitiated) {
  for (var a = 0; a < stage.length; a++) {
    var on = a === i;
    stage[a].classList.toggle('is-on', on);
    // Never leave audio playing behind a hidden gallery slide. When a shopper
    // explicitly opens a video, start it with sound; browsers allow audible playback
    // because the action comes directly from that click/tap.
    var vid = stage[a].querySelector('video');
    if (vid) {
      if (!on && !vid.paused) vid.pause();
      if (on && userInitiated) {
        vid.defaultMuted = false;
        vid.muted = false;
        if (vid.paused) { var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
      }
    }
  }
  for (var b = 0; b < thumbs.length; b++) thumbs[b].setAttribute('aria-current', b === i ? 'true' : 'false');
}
for (var t = 0; t < thumbs.length; t++) {
  (function (i) { thumbs[i].addEventListener('click', function () { show(i, true); }); })(t);
}

  /* ── variant ─────────────────────────────────────────────────── */
  var picked = (D.variants && D.variants[0]) || null;
  var opts = document.querySelectorAll('.opt');
  for (var o = 0; o < opts.length; o++) {
    (function (btn) {
      btn.addEventListener('click', function () {
        for (var k = 0; k < opts.length; k++) opts[k].setAttribute('aria-pressed', 'false');
        btn.setAttribute('aria-pressed', 'true');
        var idx = parseInt(btn.getAttribute('data-vi'), 10);
        picked = D.variants[idx] || picked;
      });
    })(opts[o]);
  }

  /* ── the gate ────────────────────────────────────────────────────
     CloakIt decides, in the visitor's own browser, whether this person reaches the
     checkout. Running it here rather than through a backend is deliberate: the engine
     then reads the real client IP and the genuine Chrome client hints, which is what it
     scores on. A proxied call has to forward every header by hand or real buyers come
     back "spoofed".

     Any failure — network, timeout, bad response — falls to the form. The offer is never
     handed out on a guess.                                                            */
  var decision = null;

  function decide() {
    if (decision) return decision;
    decision = new Promise(function (resolve) {
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 6000);
      fetch(D.ck, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token: D.ct, url: location.href, referer: document.referrer || '' }),
        signal: ctl ? ctl.signal : undefined,
        credentials: 'omit',
        cache: 'no-store',
      })
        .then(function (r) { return r.json(); })
        .then(function (d) { clearTimeout(timer); resolve(d && d.page ? d : { page: 'white' }); })
        .catch(function () { clearTimeout(timer); resolve({ page: 'white', verdict: 'error', reasons: ['gate_unreachable'] }); });
    });
    return decision;
  }

  // Ask as soon as the visitor shows any sign of being one, so the answer is already in
  // hand by the time they click. A crawler that never scrolls or points never costs a call.
  var warmed = false, gateFired = false;
  function warm() {
    if (warmed) return;
    warmed = true;
    ev('engaged');
    ['pointerdown', 'pointermove', 'touchstart', 'scroll', 'keydown'].forEach(function (e) {
      window.removeEventListener(e, warm, true);
    });
  }
  ['pointerdown', 'pointermove', 'touchstart', 'scroll', 'keydown'].forEach(function (e) {
    window.addEventListener(e, warm, { capture: true, passive: true });
  });

  /* ── checkout hand-off ───────────────────────────────────────── */
  function clickId() {
    var r = '';
    var bytes = new Uint8Array(5);
    if (window.crypto && crypto.getRandomValues) {
      crypto.getRandomValues(bytes);
      for (var i = 0; i < bytes.length; i++) r += ('0' + bytes[i].toString(16)).slice(-2);
    } else {
      r = Math.random().toString(16).slice(2, 12);
    }
    return 'fp' + Date.now().toString(36) + r;
  }

  function checkoutUrl(base) {
    var name = D.title + (picked && picked.label ? ' — ' + picked.label : '');
    var sub1 = clickId();
    var p = [];
    var add = function (k, v) {
      if (v === undefined || v === null || v === '') return;
      p.push(k + '=' + encodeURIComponent(v));
    };
    add('sub1', sub1);
    // Routed by prefix at ils.anonbusiness.com/pb — without it the conversion lands
    // in another store's ledger.
    add('sub2', 'fp-' + sub1);
    add('source_id', D.src);
    // Name and image travel in ONE slot joined by three underscores. A bare adv2 makes
    // the offer split them into two cart lines, the second named after the image URL.
    add('adv1', D.img ? name + '___' + D.img : name);
    add('sub5', D.px);
    add('sub9', 'nl|' + D.handle + (picked && picked.label ? '|' + picked.label : ''));
    add('img', D.img);   // per-product thumbnail for the /pay interstitial (display only, not forwarded)
    var _qs = location.search || '';
    var gp = function (n) { var m = _qs.match(new RegExp('[?&]' + n + '=([^&]+)')); return m ? decodeURIComponent(m[1]) : ''; };
    var gc = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
    add('fbclid', gp('fbclid'));   // LIVE url fbclid only — a persisted _fbc cookie over-attributes past FB clicks
    add('gclid', gp('gclid'));
    return base + (base.indexOf('?') >= 0 ? '&' : '?') + p.join('&');
  }

  /* ── gate UI ─────────────────────────────────────────────────── */
  var gate = document.getElementById('gate');
  var gateForm = document.getElementById('gate-form');
  var lastVerdict = null;

  function openGate() {
    if (!gate) return;
    gate.hidden = false;
    document.body.style.overflow = 'hidden';
    var f = gate.querySelector('input[name="name"]');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeGate() {
    if (!gate) return;
    gate.hidden = true;
    document.body.style.overflow = '';
  }
  var closers = document.querySelectorAll('[data-gate-close]');
  for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', closeGate);
  if (gate) {
    gate.addEventListener('click', function (e) { if (e.target === gate) closeGate(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeGate(); });
  }

  /* ── buy → our own checkout (bridge → Airwallex) ─────────────────
     2026-09-30. The ilsmedia/CloakIt hand-off is gone: the flow behind this page's
     token was deleted, so every decide() answered `unknown_flow`/block and 100% of
     buyers fell into the lead form — which posted to a 502. These pages now sell for
     real. Same base64url cart the shed rail sends; checkout.fietspack.shop re-prices
     on variant id server-side, so the numbers below are display only. */
  function goBridge(btn, label) {
    try {
      var v = picked || (D.variants && D.variants[0]) || {};
      var euros = Math.round(Number(v.price) || 0) / 100;
      var vlabel = v.label ? ' — ' + v.label : '';
      var items = [{ id: String(v.vid || ''), q: 1, title: D.title + vlabel, line: euros, img: D.img }];
      var cart = { cur: 'EUR', sym: '€', total: euros, items: items };
      var b64 = btoa(unescape(encodeURIComponent(JSON.stringify(cart))))
        .replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      /* attribution → checkout: live URL first, then this visit's first-touch snapshot */
      var qs = '';
      try {
        var gp3 = function (n) { var m = (location.search || '').match(new RegExp('[?&]' + n + '=([^&]+)')); try { return m ? decodeURIComponent(m[1].replace(/\+/g, '%20')) : ''; } catch (ed) { return ''; } };
        var gc3 = function (n) { var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]+)')); return m ? m[1] : ''; };
        var at = { ttclid: gp3('ttclid'), fbclid: gp3('fbclid'), gclid: gp3('gclid'),
                   utm_source: gp3('utm_source'), utm_medium: gp3('utm_medium'), utm_campaign: gp3('utm_campaign'),
                   utm_content: gp3('utm_content'), aff: gp3('aff'), ttp: gc3('_ttp') };
        var st3 = {}; try { st3 = JSON.parse(sessionStorage.getItem('fp_attr0') || '{}') || {}; } catch (e3) { st3 = {}; }
        for (var sk in st3) { if (!at[sk] && st3[sk]) at[sk] = String(st3[sk]); }
        for (var ak in at) { if (at[ak]) qs += '&' + ak + '=' + encodeURIComponent(at[ak]); }
      } catch (e2) {}
      window.location.href = (D.pay || 'https://checkout.fietspack.shop') + '/pay/?cart=' + b64 + qs;
    } catch (e) { btn.innerHTML = label; delete btn.dataset.busy; }
  }

  var buys = document.querySelectorAll('[data-buy]');
  for (var q = 0; q < buys.length; q++) {
    buys[q].addEventListener('click', function () {
      var btn = this;
      if (btn.dataset.busy) return;
      btn.dataset.busy = '1';
      var label = btn.innerHTML;
      btn.innerHTML = 'Even geduld…';
      ev('click');
      goBridge(btn, label);
    });
  }

  /* ── order form ──────────────────────────────────────────────── */
  if (gateForm) {
    gateForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var fd = new FormData(gateForm);
      var err = gate.querySelector('[data-gate-err]');
      var name = String(fd.get('name') || '').trim();
      var email = String(fd.get('email') || '').trim();
      if (!name || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
        if (err) err.hidden = false;
        return;
      }
      if (err) err.hidden = true;
      var sub = gateForm.querySelector('.gate__submit');
      if (sub) { sub.disabled = true; sub.innerHTML = 'Versturen…'; }

      var body = {
        name: name, email: email,
        phone: fd.get('phone') || '', street: fd.get('street') || '',
        postcode: fd.get('postcode') || '', city: fd.get('city') || '',
        note: fd.get('note') || '', hp: fd.get('fp_ref') || '',
        product: D.title, variant: (picked && picked.label) || '',
        page: location.href,
        verdict: (lastVerdict && lastVerdict.verdict) || '',
        reasons: (lastVerdict && lastVerdict.reasons) || [],
        country: (lastVerdict && lastVerdict.country) || '',
        cloak_ip: (lastVerdict && lastVerdict.ip) || '',
      };
      // The person is told it worked either way. A failed send is our problem to find in
      // the log, not theirs to retry into a form that may be talking to nothing.
      var finish = function () {
        gate.querySelector('[data-gate-step="form"]').hidden = true;
        gate.querySelector('[data-gate-step="done"]').hidden = false;
      };
      fetch(D.lead, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
        credentials: 'omit',
      }).then(finish).catch(finish);
    });
  }

  /* ── sticky buy bar ──────────────────────────────────────────── */
  var bar = document.querySelector('.sticky');
  var anchor = document.querySelector('.offer');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      bar.classList.toggle('is-on', !es[0].isIntersecting && es[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ── scroll reveal ───────────────────────────────────────────── */
  var rv = document.querySelectorAll('.rv');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var r = 0; r < rv.length; r++) io.observe(rv[r]);
  } else {
    for (var s = 0; s < rv.length; s++) rv[s].classList.add('is-in');
  }

  ev('view');
})();
